<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .upload-area-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .file-upload-container {
      position: relative;
    }

    .drag-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 116, 228, 0.15);
      border: 2px dashed colors.get(primary_40);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      pointer-events: none;
      height: 150px;

      .drag-message {
        @include mixins.h4;
        background-color: colors.get(interfaceWhite);
        padding: 16px 32px;
        border-radius: 8px;
        color: colors.get(primary_40);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .upload-progress-wrapper {
    gap: 8px;

    .uploading-text {
      @include mixins.body4-badge;
      color: colors.get(textDisabledGrey);
      text-align: left;
    }
  }
</style>

<script>
  import FileUpload from "@sourcewhale/shared/svelte-design-system/components/molecules/FileUpload/FileUpload.svelte";
  import UploadProgress from "@sourcewhale/shared/svelte-design-system/components/molecules/UploadProgress/UploadProgress.svelte";
  import { RESUME_FILE_CONFIG } from "../../assets";
  import { isDraggingFilesStore, persistedFilesStore } from "../../stores";

  let { isUploading = false, progress = 0, errorMessage = "" } = $props();

  const onFilesSelected = ({ files }) => {
    if (Array.isArray(files)) {
      $persistedFilesStore = files;
    } else if (files) {
      $persistedFilesStore = [files];
    } else {
      $persistedFilesStore = [];
    }
  };
</script>

<div class="upload-area-wrapper">
  {#if isUploading}
    <div class="upload-progress-wrapper">
      <div class="uploading-text">
        {progress === 100 ? "Files Uploaded" : "Uploading..."}
      </div>
      <UploadProgress {progress} {errorMessage} />
    </div>
  {/if}

  <div class="file-upload-container">
    {#if $isDraggingFilesStore && !isUploading}
      <div class="drag-overlay">
        <div class="drag-message">Drop Files here</div>
      </div>
    {/if}

    <FileUpload
      maxFiles={100}
      allowedTypes={RESUME_FILE_CONFIG.allowedTypes}
      maxFileSize={RESUME_FILE_CONFIG.maxFileSize}
      acceptedExtensions={RESUME_FILE_CONFIG.acceptedExtensions}
      uploadText="Drop one or more file(s) here or click to browse"
      uploadSubtext="Supports PDF or DOCX files up to 64MB each"
      invalidTypeError="Please select a PDF or Word document"
      fileTooLargeError="File size must be less than 64MB"
      {isUploading}
      bind:selectedFiles={$persistedFilesStore}
      {onFilesSelected}
    />
  </div>
</div>
